/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserGroupMembership {
    getFixupPrototypeFunction() { return UserGroupMembership.fixupPrototype; }

    static newInstance(model: Partial<UserGroupMembership>): UserGroupMembership {
        let obj = Object.assign(new UserGroupMembership(), model);
        UserGroupMembership.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserGroupMembership>): UserGroupMembership {
        if (!model) return null;
        return UserGroupMembership.newInstance(<UserGroupMembership> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserGroupMembership) {
        if (!obj) return;

        models.UserGroupMembership.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserGroupMembership): boolean {
        Object.setPrototypeOf(obj, UserGroupMembership.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the user group
     */
    id: string;

    /**
     * Name of the user group
     */
    group_name: string;

}
